import { LinkManager, LinkItem } from "../../../atoms/LinkManager";
import { IRedirectionLink } from "./types";
import useAuth from "../../../../hooks/useAuth";
import { usePermissions } from "../../../../utils/permissions";
import { Cap, Level } from "../../../../utils/rbacCatalog";

interface RedirectionLinksProps {
  data?: IRedirectionLink[];
  OnSubmit: (data: Array<IRedirectionLink>) => Promise<void>;
  maxLinks: number;
}

const RedirectionLinks = ({
  data,
  OnSubmit,
  maxLinks,
}: RedirectionLinksProps) => {
  const { user } = useAuth();
  const permissions = usePermissions(user);
  const canWrite = permissions.can(Cap.LOYALTY, Level.WRITE);

  const handleSubmit = async (formData: { links: LinkItem[] }) => {
    if (!canWrite) return;
    return OnSubmit(formData.links as IRedirectionLink[]);
  };

  return (
    <div className="w-full mt-2">
      <fieldset disabled={!canWrite} className="border-0 m-0 p-0 min-w-0">
        <LinkManager
          data={data as LinkItem[]}
          onSubmit={handleSubmit}
          maxLinks={maxLinks}
          allowHttp={false}
          autoSave={false}
          className=""
          showIconField={true}
          showCustomIconUrl={true}
          canEdit={canWrite}
        />
      </fieldset>
      <div className="self-stretch h-px bg-gray-200 block mt-4" />
    </div>
  );
};

export default RedirectionLinks;
